import { render, staticRenderFns } from "./menu-popup-container.vue?vue&type=template&id=0315929b&"
import script from "./menu-popup-container.vue?vue&type=script&lang=js&"
export * from "./menu-popup-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports